var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useState, } from 'react';
import { useSearchParams } from 'react-router-dom';
var ListContext = createContext(undefined);
export var useList = function () {
    var context = useContext(ListContext);
    if (!context) {
        throw new Error('useList must be used within a ListProvider');
    }
    return context;
};
export var ListProvider = function (_a) {
    var _b = _a.defaultSortField, defaultSortField = _b === void 0 ? 'id' : _b, _c = _a.defaultSortOrder, defaultSortOrder = _c === void 0 ? 'desc' : _c, children = _a.children, fetchItems = _a.fetchItems, filterFields = _a.filterFields;
    var _d = useSearchParams(), searchParams = _d[0], setSearchParams = _d[1];
    var _e = useState([]), items = _e[0], setItems = _e[1];
    var _f = useState(Number(searchParams.get('page')) || 1), currentPage = _f[0], setCurrentPage = _f[1];
    var _g = useState(0), totalItems = _g[0], setTotalItems = _g[1];
    var pageSize = useState(10)[0];
    var _h = useState(searchParams.get('order') || defaultSortOrder || 'desc'), sortOrder = _h[0], setSortOrder = _h[1];
    var _j = useState(searchParams.get('sortBy') || defaultSortField), sortField = _j[0], setSortField = _j[1];
    var _k = useState({}), filters = _k[0], setFilters = _k[1];
    var _l = useState(false), isLoading = _l[0], setIsLoading = _l[1];
    var totalPages = Math.ceil(totalItems / pageSize);
    useEffect(function () {
        var updatedFilters = {};
        filterFields.forEach(function (field) {
            var value = searchParams.get(field.name);
            if (value) {
                updatedFilters[field.name] = value;
            }
        });
        setFilters(updatedFilters);
        setCurrentPage(Number(searchParams.get('page')) || 1);
        setSortOrder(searchParams.get('order') || defaultSortOrder);
        setSortField(searchParams.get('sortBy') || defaultSortField);
    }, [searchParams, filterFields]);
    var loadItems = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    params = {
                        page: currentPage,
                        pageSize: pageSize,
                        sortOrder: sortOrder,
                        sortField: sortField,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, fetchItems(filters, params)];
                case 2:
                    data = _a.sent();
                    setItems(data.items);
                    setTotalItems(data.total);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [currentPage, fetchItems, filters, sortOrder]);
    var applyFiltersAndOrder = function (newFilters, newOrder, newSortField, newPage) {
        var newSearchParams = new URLSearchParams();
        Object.keys(newFilters).forEach(function (key) {
            if (newFilters[key]) {
                newSearchParams.set(key, newFilters[key]);
            }
            else {
                newSearchParams.delete(key);
            }
        });
        if (newOrder !== defaultSortOrder) {
            newSearchParams.set('order', newOrder);
        }
        else {
            newSearchParams.delete('order');
        }
        if (newSortField !== defaultSortField) {
            newSearchParams.set('sortBy', newSortField);
        }
        else {
            newSearchParams.delete('sortBy');
        }
        if (newPage !== 1) {
            newSearchParams.set('page', newPage.toString());
        }
        else {
            newSearchParams.delete('page');
        }
        setSearchParams(newSearchParams);
    };
    useEffect(function () {
        loadItems();
    }, [currentPage, sortOrder, filters, loadItems]);
    var setPage = function (page) {
        if (page > 0 && page <= totalPages) {
            applyFiltersAndOrder(filters, sortOrder, sortField, page);
        }
    };
    return (_jsx(ListContext.Provider, { value: {
            items: items,
            currentPage: currentPage,
            setPage: setPage,
            totalItems: totalItems,
            pageSize: pageSize,
            totalPages: totalPages,
            order: sortOrder,
            setOrder: function (newOrder) {
                return applyFiltersAndOrder(filters, newOrder, sortField, currentPage);
            },
            filters: filters,
            setFilters: function (newFilters) {
                return applyFiltersAndOrder(newFilters, sortOrder, sortField, 1);
            },
            filterFields: filterFields,
            refresh: loadItems,
            isLoading: isLoading,
        }, children: children }));
};
